import { render, staticRenderFns } from "./LafiaOptionItem.vue?vue&type=template&id=5ad77fe6&scoped=true"
import script from "./LafiaOptionItem.vue?vue&type=script&lang=js"
export * from "./LafiaOptionItem.vue?vue&type=script&lang=js"
import style0 from "./LafiaOptionItem.vue?vue&type=style&index=0&id=5ad77fe6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ad77fe6",
  null
  
)

export default component.exports